import {Validator} from '../../Core/validator';
import {KeyEvent} from '../../Core/key-events';
import {numberFormat} from "../../Core/common";

let events = null;

const items = new Map();


const print = (element, price, count) => {

    if (element.dataset.basecountitem) {
        price = count * element.dataset.discountprice;

    }

    let priceBox = element.querySelector('.js_item_total_price');

    if (priceBox) {
        priceBox.innerHTML = numberFormat(price || 0, 2, '.');
    }

    let itemSquare = element.querySelector('.js_item_square');

    if (itemSquare) {
        let baseCountItem = parseFloat(element.dataset.basecountitem);
        let countItem = parseFloat(element.dataset.countitem);
        let resultData = countItem / baseCountItem * Math.ceil(count);
        itemSquare.value = Math.ceil10(resultData, -2);
    }

    let without_discount_price = element.querySelector('.js_item_total_without_discount_price');
    if (element.dataset.defaultrice && without_discount_price && count > 0) {
        without_discount_price.innerHTML = numberFormat(element.dataset.defaultrice * count || 0, 2, '.');
    } else if (element.dataset.without_discount_price && without_discount_price && count > 0) {
        without_discount_price.innerHTML = numberFormat(element.dataset.without_discount_price * count || 0);
    }

    //element.querySelector('.ALL').innerHTML = numberFormat(price)
    let messagebox = element.querySelector('.js_item_message');
    if (messagebox) {
        if (!count) {
            messagebox.classList.remove('d-none');
            messagebox.classList.remove('text-success');
            messagebox.classList.add('text-danger');
            messagebox.innerHTML = "Добавьте или удалите как минимум 1 товар.";
        } else {
            messagebox.classList.add('d-none');
        }
    }
};

const setTotal = (options) => {
    if (options.count && options.price) {
        options.totalPrice = options.count * options.price;
    } else {
        options.totalPrice = 0;
    }
    return options;
};
const calculateCount = (cnt, element, input) => {

    let currentInput = items.get(element);

    cnt = parseFloat(isNaN(cnt) ? 0 : cnt);
    let newInput = setTotal({...currentInput, count: cnt});
    items.set(element, newInput);

    input.value = newInput.count;

    let data = [{count: newInput.count, price: newInput.price, totalPrice: newInput.totalPrice}];

    if (newInput.count) {
        events.dispatch('paper.update', element, [...data]);
    }

    print(element, newInput.totalPrice, newInput.count);
};
const setInputValue = (input, set) => {
    let cnt = input.value;
    set(input);
    if (input.value < 0) {
        input.value = cnt;
    }
    return input.value;
};

const incrementSegment = (element, input) => calculateCount(setInputValue(input, (input) => input.value = +input.value + 1), element, input);

const decrementSegment = (element, input) => calculateCount(setInputValue(input, (input) => input.value = +input.value - 1), element, input);

let inputTimer = null;
const inputForSegment = (element, input, evt) => {
    if (!Validator.isNumber(evt.key) &&
        !(
            evt.keyCode === KeyEvent.DOM_VK_BACK_SPACE ||
            evt.keyCode === KeyEvent.DOM_VK_DELETE
        )
    ) {

        evt.preventDefault();
    }

    clearTimeout(inputTimer);
    inputTimer = setTimeout(() => calculateCount(input.value, element, input), 500);
};

const elementInitEvents = (element, input) => {

    const increment = input.closest('.count-number').querySelector('.format_increment');
    const decrement = input.closest('.count-number').querySelector('.format_decrement');

    if (increment) {
        increment.removeEventListener('click', incrementSegment.bind(null, element, input), false);
        increment.addEventListener('click', incrementSegment.bind(null, element, input), false);
    }

    if (decrement) {
        decrement.removeEventListener('click', decrementSegment.bind(null, element, input), false);
        decrement.addEventListener('click', decrementSegment.bind(null, element, input), false);
    }
    let timer;
    input.addEventListener('keydown', event => {
        element.querySelector('.js_item_total_price').classList.add('preloader');
        clearTimeout(timer);
        timer = setTimeout(() => {
            inputForSegment(element, input, event);
        }, 1500);
    });

    element.querySelectorAll('.js_item_square').forEach(item => {
        item.addEventListener('keydown', () => {

            let baseCountItem = parseFloat(element.dataset.basecountitem);
            let countItem = parseFloat(element.dataset.countitem);

            console.log(input.value, item.value);

            clearTimeout(timer);
            timer = setTimeout(() => {
                input.value = Math.ceil(baseCountItem / countItem * item.value);
                let event = new Event('keydown');
                input.dispatchEvent(event);
            }, 1000);
        });
    });
};

const elementRemoveEvents = (input) => {
    const increment = input.parentNode.querySelector('.format_increment');
    const decrement = input.parentNode.querySelector('.format_decrement');

    if (increment) {
        increment.removeEventListener('click', incrementSegment);
    }

    if (decrement) {
        decrement.removeEventListener('click', decrementSegment);
    }

    input.removeEventListener('keydown', inputForSegment);
};

const deleteItem = item => {
    let list = items.get(item);
    if (list) {
        elementRemoveEvents(list.input);
        items.delete(item);
    }
};


const init = itemSelectors => {

    document.querySelectorAll(itemSelectors).forEach(item => {
        let options = {
            count: 0,
            itemId: item.dataset.item || 0,
            totalPrice: 0,
            price: item.dataset.price || 0
        };

        item.querySelectorAll('.js_count_component').forEach(component => {

            elementInitEvents(item, component);
            let cnt = parseFloat(isNaN(component.value) ? 0 : component.value);
            options = {...options, count: cnt, input: component};
        });

        items.set(item, setTotal(options));
    });
};
export const calculator = (event) => {
    events = event;
    return {
        init: selector => init(selector),
        delete: item => deleteItem(item),
    };
};
